export default {
    common: {
        "slogan":"TENGDAFEI Quick Release. Stay Ahead.",
        home: "Home",
        category: "Categories",
        address: "My Address",
        order: "My Orders",
        favorite: "My Favorites",
        cart: "Cart",
        about: "About Us",
        agreement: "Disclaimer",
        concat: "Contact Us",
        logout: "Log Out",
        search: "Search",
        input: "Enter product name or model",
        visit: "Total Visits: ",
        start: "From",
        quantity: "Qty",
        back_home: "back to Home",

        user_center: "UserConter",
        new_order: "New Order",
        order_detail: "Order Details",
        close: "Close",
        pay: "OrderPay",
        confirm_logout: "Confirm to Logout?",
        confirm: "Confirm",
        confirm_delete:"confirm Delete?",
        post_sales:"After Sales Policy",
        faq:"FAQ",
    },
    category1s: [
        "Hardware",
        "Quick Release",
        "Photo Gear",
        "Bike Mounts",
        "Light Pipe",
        "Outdoor Gear"
    ],
    home: {
        "productCategories":"Product Categories",
        newProducts: "New Arrivals",
        hotProducts: "Best Sellers",
        goodProducts: "Recommended"
    },
    search: {
        search: "Search Products"
    },
    mall: {
        category: "Select Category",
        search: "Search Product",
    },
    product: {
        price_start: "Starting Price",
        shipping_fee: "Shipping",
        category: "Category",
        region_normal: "Main Provinces",
        region_other: "HK/Macau/Taiwan & Overseas ¥99",
        region_far: "Remote Areas ¥12 (Xinjiang, Tibet, Inner Mongolia, Qinghai, Ningxia, Gansu)",
        sells: "Sales",
        favorite: "Favorite",
        favorited: "Favorited",
        add_cart: "Add to Cart",
        buy_now: "Buy",
        detail: "Details",
        comments: "Reviews",
        select: "Select Model",
        stock: "Stock",
        buy: "Buy",
        preview: "3D Preview",
        empty_comments: "No reviews yet",
        download: "Download File",
        concat:"Concat",
        hotline:"HotLine",
        email:"E-mail",
        com_wechat:"Wechat",
    },
    login: {
        login_register: "Login / Register",
        mobile: "Mobile",
        code: "Code",
        send_code: "Send",
        login: "Login",
        input_mobile: "Please enter your mobile number",
        digit4: "4-digit number",
        second: "s"
    },
    address: {
        concat: "Contact",
        mobile: "Mobile",
        address: "Detailed Address",
        modify: "Edit Address",
        remove: "Delete Address",
        save: "Save Address",
        add: "Add Address",
        zipcode: "Zip Code",
        digit6: "6-digit number",
        mobile11: "11-digit mobile number",
        name: "Name",
        gender: "Gender",
        male: "Mr.",
        female: "Ms.",
        province: "Area",
        please_select: "Please Select",
        is_mainland: "Region",
    },
    cart: {
        order_now: "Order Now"
    },
    order: {
        order_no: "Full Order Number",
        no: "Order#",
        search: "Search",
        detail: "Details",
        order_detail: "Order Details",
        fee: "Amount",
        new_time: "Order Time",
        status: "Status",
        all: "All",
        shipping_fee: "Shipping Fee",
        cover: "Product Image",
        product: "Product Name",
        price: "Price",
        count: "Quantity",
        price_count: "Price & Quantity",
        order_fee: "Order Amount",
        rule: "Rules",
        remark: "Order Note",
        address: "Shipping Address",
        pay_way: "Payment Method",
        track: "Order Tracking",
        express_no: "Tracking Number",
        express: "Courier Company",
        time: "Time",
        cancel: "Cancel Order",
        pay_now: "Pay Now",
        comments: "Order Reviews",
        comment: "Review",
        confirm: "Confirm Receipt",
        rank: "Rating",
        submit: "Submit Review",
        wechatpay: "WeChat Pay",
        alipay: "Alipay",
        select_payway: "Please select a payment method",
        support: "We now support",
        paying: "Processing payment...",
        confirm_cancel: "Are you sure you want to cancel this order?",
        hour2: "(Please scan the code to pay within 2 hours)",
        scan: "Scan the QR code with WeChat on your phone to pay",
        alipay_please: "The payment window has opened. Please complete the payment on the Alipay page.",
        pay_done: "Payment Completed",
        addresses: "Address Management",
        please_select: "Please select",
        fee_rule: "Shipping Fee Rules",
        order_now: "Order Now",
        region: "Region",
        area: "Area",
        select_area:"Please select Area",
        please_address:"Please select address!",
         refund:"Apply Refund",
        reason:"Reason",
    },
    footer:{
        "product_center":"Product Center",
        "service_notice":"Service Description",
        "notice1":"Supports drawings and samples · OEM/ODM",
        "notice2":"Metric/Imperial · Customized Non-standard"
    }
}